import { Stack, styled, Typography, type CSSObject } from '@mui/material';

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  paddingBottom: theme.spacing(0.5),
}));

export const StyledTextWrapper = styled(Stack)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  gap: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(1),
  },
}));
